
{
  "familyId": "MET-OPP-OMREKENEN",
  "questions": [
    {
      "id": "MET-OPP-OMREKENEN-001",
      "familyId": "MET-OPP-OMREKENEN",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel cm² is 3 dm²?",
      "options": ["300 cm²", "30 cm²", "3000 cm²", "0,03 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "stairs", "data": {"unit": "oppervlakte", "from": "dm²", "to": "cm²", "value": 3, "highlight": true}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Oppervlakte omrekenen", "content": "Bij oppervlakte ga je steeds × 100 (niet × 10!). 1 dm² = 100 cm². Dus 3 dm² = 3 × 100 = 300 cm².", "icon": "lightbulb"}}],
      "conceptId": "opp_dm2_naar_cm2",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Bij oppervlakte vermenigvuldig je met 100 per stap (niet met 10). 1 dm² = 100 cm². Dus 3 dm² = 3 × 100 = 300 cm².",
        "solutionSteps": [
          "1 dm² = 100 cm² (want 10 cm × 10 cm = 100 cm²)",
          "3 × 100 = 300 cm²",
          "Onthoud: bij oppervlakte ×100 per stap, niet ×10"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 dm² = 3 × 100 = 300 cm².",
          "1": "Je dacht waarschijnlijk dat je met 10 moest vermenigvuldigen. Maar bij oppervlakte ga je × 100 per stap, niet × 10. Onthoud: oppervlakte = lengte × lengte, dus 10 × 10 = 100.",
          "2": "Je dacht waarschijnlijk dat je met 1000 moest vermenigvuldigen. Maar van dm² naar cm² is maar 1 stap = × 100. Onthoud: elke stap bij oppervlakte is × 100.",
          "3": "Je hebt gedeeld in plaats van vermenigvuldigd. Van een grotere eenheid naar een kleinere eenheid ga je × 100, niet ÷ 100. Onthoud: kleiner = meer, dus vermenigvuldigen."
        }
      }
    },
    {
      "id": "MET-OPP-OMREKENEN-002",
      "familyId": "MET-OPP-OMREKENEN",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel m² is 50.000 cm²?",
      "options": ["5 m²", "50 m²", "500 m²", "0,5 m²"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "stairs", "data": {"unit": "oppervlakte", "from": "cm²", "to": "m²", "value": 50000, "highlight": true}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Oppervlakte omrekenen", "content": "Van cm² naar m² is 2 stappen: cm² → dm² → m². Elke stap ÷ 100. Dus: 50.000 ÷ 100 ÷ 100 = 5 m².", "icon": "lightbulb"}}],
      "conceptId": "opp_cm2_naar_m2",
      "variantIndex": 2,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Van cm² naar m² is 2 stappen (cm² → dm² → m²). Elke stap ÷ 100. Dus: 50.000 ÷ 100 = 500 dm². Dan 500 ÷ 100 = 5 m².",
        "solutionSteps": ["Van cm² naar m² = 2 stappen", "50.000 ÷ 100 = 500 dm²", "500 ÷ 100 = 5 m²"],
        "distractorExplanations": {
          "0": "Goed! 50.000 ÷ 10.000 = 5 m².",
          "1": "Je dacht waarschijnlijk dat je maar 1 stap hoefde te doen (÷ 100 = 500, dan ÷ 10 = 50). Maar elke stap is ÷ 100, niet ÷ 10. Onthoud: oppervlakte = × 100 per stap.",
          "2": "Je dacht waarschijnlijk dat je maar door 100 hoefde te delen. Maar van cm² naar m² is 2 stappen: ÷ 100 ÷ 100 = ÷ 10.000. Onthoud: tel het aantal stappen op het trapje.",
          "3": "Je dacht waarschijnlijk dat je door 100.000 moest delen. Maar van cm² naar m² is ÷ 10.000 (2 stappen × 100). Onthoud: cm² → dm² (÷100) → m² (÷100)."
        }
      }
    },
    {
      "id": "MET-OPP-OMREKENEN-003",
      "familyId": "MET-OPP-OMREKENEN",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_omrekenen",
      "questionType": "multiple_choice",
      "question": "Waarom vermenigvuldig je bij oppervlakte met 100 per stap, en niet met 10?",
      "options": ["Omdat oppervlakte lengte × breedte is, dus 10 × 10 = 100", "Omdat oppervlakte altijd in honderdtallen is", "Omdat het metrieke stelsel zo werkt", "Omdat je twee keer moet omrekenen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Waarom × 100?", "content": "Oppervlakte = lengte × breedte. Als je de lengte-eenheid met 10 vermenigvuldigt, doe je dat twee keer (voor lengte én breedte): 10 × 10 = 100.", "icon": "lightbulb"}}],
      "conceptId": "opp_waarom_100",
      "variantIndex": 3,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Oppervlakte = lengte × breedte. Als 1 dm = 10 cm, dan is 1 dm² = 10 cm × 10 cm = 100 cm². Daarom × 100 per stap.",
        "solutionSteps": ["1 dm = 10 cm", "1 dm² = 1 dm × 1 dm = 10 cm × 10 cm", "10 × 10 = 100 cm²"],
        "distractorExplanations": {
          "0": "Goed! Oppervlakte is tweedimensionaal, dus je vermenigvuldigt 10 × 10 = 100.",
          "1": "Je dacht waarschijnlijk dat het iets met honderdtallen te maken heeft. Maar het komt doordat oppervlakte twee afmetingen heeft (lengte × breedte). Onthoud: 10 × 10 = 100.",
          "2": "Je dacht waarschijnlijk dat het gewoon een regel is. Maar er zit logica achter: oppervlakte = lengte × breedte, dus de omrekenfactor wordt gekwadrateerd. Onthoud: bij lengte × 10, bij oppervlakte × 100.",
          "3": "Je dacht waarschijnlijk dat je twee keer omrekent. Dat klopt deels, maar de reden is dat oppervlakte twee dimensies heeft. Onthoud: lengte × 10, oppervlakte × 10² = 100."
        }
      }
    },
    {
      "id": "MET-OPP-OMREKENEN-004",
      "familyId": "MET-OPP-OMREKENEN",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een schilder moet 2,5 m² muur verven. Hoeveel dm² is dat?",
      "options": ["250 dm²", "25 dm²", "2500 dm²", "0,25 dm²"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "m² naar dm²", "content": "1 m² = 100 dm². Dus 2,5 m² = 2,5 × 100 = 250 dm².", "icon": "lightbulb"}}],
      "conceptId": "opp_m2_naar_dm2_context",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Bij oppervlakte ga je ×100 per stap op het metrieke trapje. 1 m² = 100 dm² (want 10 × 10 = 100). Dus 2,5 m² = 2,5 × 100 = 250 dm². Onthoud: oppervlakte heeft twee dimensies, daarom ×100 in plaats van ×10.",
        "solutionSteps": [
          "1 m² = 100 dm² (want 10 dm × 10 dm = 100 dm²)",
          "2,5 × 100 = 250 dm²",
          "Controleer: 250 ÷ 100 = 2,5 m² ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 1 m² = 100 dm², dus 2,5 × 100 = 250 dm².",
          "1": "Je dacht waarschijnlijk dat je met 10 moest vermenigvuldigen. Maar bij oppervlakte is het × 100 per stap. Onthoud: oppervlakte = × 100.",
          "2": "Je dacht waarschijnlijk dat je met 1000 moest vermenigvuldigen. Maar van m² naar dm² is maar 1 stap = × 100. Onthoud: tel de stappen op het trapje.",
          "3": "Je hebt gedeeld in plaats van vermenigvuldigd. Van m² naar dm² ga je naar een kleinere eenheid, dus je vermenigvuldigt. Onthoud: kleiner = meer = vermenigvuldigen."
        }
      }
    },
    {
      "id": "MET-OPP-OMREKENEN-005",
      "familyId": "MET-OPP-OMREKENEN",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_omrekenen",
      "questionType": "fill_in",
      "question": "Hoeveel cm² is 4,5 dm²? Typ je antwoord (bijv. 450).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["450", "450 cm²"],
        "caseSensitive": false,
        "placeholder": "? cm²"
      },
      "stimulusAids": [{"type": "stairs", "data": {"unit": "oppervlakte", "from": "dm²", "to": "cm²", "value": 4.5, "highlight": true}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "dm² naar cm²", "content": "1 dm² = 100 cm². Dus 4,5 × 100 = 450 cm².", "icon": "lightbulb"}}],
      "conceptId": "opp_dm2_naar_cm2_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bij oppervlakte ga je ×100 per stap. 1 dm² = 100 cm² (want 10 × 10 = 100). Dus 4,5 dm² = 4,5 × 100 = 450 cm². Onthoud: oppervlakte heeft twee dimensies, daarom ×100 in plaats van ×10.",
        "solutionSteps": ["1 dm² = 100 cm²", "4,5 × 100 = 450 cm²"]
      }
    }
  ]
}
